var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#53A6DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 16H18.6667C17.1939 16 16 17.1939 16 18.6667V37.3333C16 38.8061 17.1939 40 18.6667 40H37.3333C38.8061 40 40 38.8061 40 37.3333V18.6667C40 17.1939 38.8061 16 37.3333 16Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 25.332C24.4378 25.332 25.3333 24.4366 25.3333 23.332C25.3333 22.2275 24.4378 21.332 23.3333 21.332C22.2287 21.332 21.3333 22.2275 21.3333 23.332C21.3333 24.4366 22.2287 25.332 23.3333 25.332Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 31.9987L33.3334 25.332L18.6667 39.9987",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.07110950523f2b9c0a7f2832fe1b19df.svg";
export { ForwardRef as ReactComponent };